import { Link } from "react-router-dom";
import type { NewsItem } from "@/mocks/news";

interface NewsCardProps {
  item: NewsItem;
}

export default function NewsCard({ item }: NewsCardProps) {
  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:flex-row md:gap-6 md:p-6"
    >
      <div className="h-48 w-full shrink-0 overflow-hidden rounded-md md:h-44 md:w-72">
        <img
          src={item.cover}
          alt={`${item.title} - 张津瑜资讯封面`}
          title={`${item.title} + 张津瑜资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-3">
          <span className="rounded-full bg-primary-50 px-3 py-1 font-label text-xs font-medium text-primary-700">
            {item.category}
          </span>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-calendar-line" />
            {item.date}
          </span>
          <span className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-eye-line" />
            {item.views.toLocaleString()}
          </span>
        </div>
        <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
          {item.title}
        </h3>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <div className="mt-4 flex flex-wrap items-center gap-2">
          {item.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900"
            >
              #{tag}
            </span>
          ))}
        </div>
        <span className="mt-auto hidden pt-4 text-sm font-medium text-primary-600 md:inline-flex md:items-center md:gap-1">
          阅读全文
          <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}